// extracted by mini-css-extract-plugin
module.exports = {"facebook-container":"SocialMediaPanel_facebook-container__17CKa"};